import { render, staticRenderFns } from "./ComposeWebmail.vue?vue&type=template&id=764e0214&scoped=true&"
import script from "./ComposeWebmail.vue?vue&type=script&lang=js&"
export * from "./ComposeWebmail.vue?vue&type=script&lang=js&"
import style0 from "./ComposeWebmail.vue?vue&type=style&index=0&id=764e0214&scoped=true&lang=css&"
import style1 from "./ComposeWebmail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e0214",
  null
  
)

export default component.exports